export const OPERATORS: { value: string; label: string }[] = [
  {
    label: "==",
    value: "==",
  },
  {
    label: "!=",
    value: "!=",
  },
  {
    label: ">",
    value: ">",
  },
  {
    label: "<",
    value: "<",
  },
  {
    label: ">=",
    value: ">=",
  },
  {
    label: "<=",
    value: "<=",
  },
];


export const STRING_OPERATORS: { value: string; label: string }[] = [
  {
    label: "==",
    value: "==",
  },
  {
    label: "!=",
    value: "!=",
  },
];

export enum PivotSortableColumn {
  CATEGORY = "category_name",
  VERSION = "version_name",
  ATTRIBUTES = "attribute",
  TOTAL_ATTRIBUTES = "attribute",
  CREATED_ON = "created_on",
  LAST_UPDATED_BY = "last_updated_by",
}


export const Invalid_Array = ["null", null, undefined, "undefined"];


export const EMPTY_PIVOT_ELEMENT = {
  pivot_attribute: "",
  operator: OPERATORS[0]?.value,
  base_attribute: "",
  weightage: "",
  pivot_attribute_name: "",
  base_attribute_name: "",
};

export const computedSubstitutionTabs: readonly ComputedSubstitutionTabType[] = ['iteration', 'weightage'] as const;
export const CREATE = "Create";
export const CANCEL = "Cancel";
export const EDIT = "Edit";